import { render, staticRenderFns } from "./SessionSwitcher.vue?vue&type=template&id=163e9b40"
import script from "./SessionSwitcher.vue?vue&type=script&lang=js"
export * from "./SessionSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports